/**
 * 门户端-首页数据
 */

import request from "@/utils/request";

/**
 * 详情获取
 */
export function getDetails() {
  return request({
    url: "/api/v1/portal/homePage/getData",
    method: "get",
  });
}

/**
 * 增加访问量
 */
export function addCount() {
  return request({
    url: "/api/v1/portal/homePage/visits",
    method: "get",
  });
}

export default {
  getDetails,
  addCount,
};
